import PropTypes from "prop-types";
import { Alert, Typography } from "antd";

const { Paragraph, Text } = Typography;

export default function ReviewFeedbackNotice({ feedback, className = "" }) {
  if (!feedback || !feedback.message) {
    return null;
  }

  const updatedLabel = feedback.updated_at
    ? new Date(feedback.updated_at).toLocaleString()
    : null;

  return (
    <Alert
      type="warning"
      showIcon
      className={`rounded-2xl border-amber-300/70 bg-amber-50 dark:bg-amber-400/10 dark:border-amber-500/40 ${className}`}
      message={
        <Text strong>
          Your post needs some updates before it can be published.
        </Text>
      }
      description={
        <div className="space-y-3">
          <div>
            <Paragraph className="mb-0 text-gray-800 dark:text-gray-200 whitespace-pre-line">
              {feedback.message}
            </Paragraph>
            {updatedLabel && (
              <Text type="secondary" className="text-xs">
                Last updated {updatedLabel}
              </Text>
            )}
          </div>
          {Array.isArray(feedback.highlights) &&
            feedback.highlights.length > 0 && (
              <div className="space-y-2">
                <Text strong className="block text-sm">
                  Focus areas
                </Text>

                <ul className="list-disc list-inside space-y-1 text-gray-800 dark:text-gray-200 text-sm">
                  {feedback.highlights.map((item, index) => (
                    <li
                      key={`feedback-highlight-${index}`}
                      className="flex items-start"
                    >
                      <div className="flex-shrink-0 mt-1 mr-2">
                        <div className="w-1.5 h-1.5 bg-current rounded-full mt-1.5" />
                      </div>
                      <div className="flex-1">
                        <div className="font-medium">
                          {item.excerpt || "Excerpt not provided"}
                        </div>
                        {item.note && (
                          <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                            {item.note}
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
        </div>
      }
    />
  );
}

ReviewFeedbackNotice.propTypes = {
  feedback: PropTypes.shape({
    message: PropTypes.string,
    highlights: PropTypes.arrayOf(
      PropTypes.shape({
        excerpt: PropTypes.string,
        note: PropTypes.string,
      })
    ),
    updated_at: PropTypes.string,
  }),
  className: PropTypes.string,
};
